<form class="modal-body" [formGroup]="form" (ngSubmit)="login()" novalidate>
  <p class="centermodal__title">{{ 'auth.accessAccount' | translate }}</p>

  <div class="centermodal__form mb-0">
    <label class="field__holder" [appFormControlWrap]="form.get('email')">
      <input type="email" class="field" name="email" formControlName="email" autocomplete="email" [appDisableInput]="!!fixedEmail" required appValidEmail #emailInput />
      <span class="field__placeholder">{{ 'auth.mail' | translate }}</span>
    </label>

    <label class="field__holder" [appFormControlWrap]="form.get('password')">
      <input type="password" class="field" formControlName="password" name="password" autocomplete="current-password" required #passwordInput />
      <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
    </label>
  </div>

  <button type="button" class="btn-S btn-text d-flex ml-auto" [disabled]="isLoading" (click)="sendResetPasswordConfirmation()">{{ 'auth.forgotPasswordQuestion' | translate }}</button>

  <div class="centermodal__button-group mt-3">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.back' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="isLoading">{{ 'button.continue' | translate }}</button>
  </div>
</form>
